wbApp.controller('PreferredBookingDetailCourseRegistrationDetailCtrl', ['$scope',
function ($scope) {

    $scope.modelCopy = angular.copy($scope.model);

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.model);
    };

    $scope.onCourseRegistrationDetailSave = function (model) {
        angular.extend($scope.model, model);
        $scope.model.isPristine = false;
        $scope.$hide();
    }

}]);
